module.exports = __webpack_public_path__ + "img/Asset-2010-100.eb35bfb5.jpg";